var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.currentValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.currentValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.classObj,
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    class: (_vm.prefixCls + "-switch-container " + _vm.prefixCls + "-switch-on-primary " + _vm.prefixCls + "-switch-off-default")
  }, [_c('span', {
    class: (_vm.prefixCls + "-switch-handle-on " + _vm.prefixCls + "-switch-primary")
  }, [_vm._v(_vm._s(_vm.ontext))]), _vm._v(" "), _c('span', {
    class: (_vm.prefixCls + "-switch-label")
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    class: (_vm.prefixCls + "-switch-handle-off " + _vm.prefixCls + "-switch-default")
  }, [_vm._v(_vm._s(_vm.offtext))])])]), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-70ffa05a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ffa05a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Switch/n3Switch.vue
// module id = 640
// module chunks = 0 1